import React, { type FC, useCallback, useEffect } from 'react'

import { useAtomCallback } from 'jotai/utils'

import { evalCondition } from 'mailup-react-helpers'
import { Flex, ToastContainer, Tooltip } from 'mailup-web-components'

import Page from 'Containers/Page'
import { routesAccessConditions } from '../../config/config'

import { initPageCallback } from 'Pages/unifiedFiltersListPage/callbacks/page'
import Header from 'Pages/unifiedFiltersListPage/components/Header'
import ModalDelete from 'Pages/unifiedFiltersListPage/components/ModalDelete'
import Search from 'Pages/unifiedFiltersListPage/components/Search'
import EngagementFiltersUpselling from '../../components/upselling/EngagementFiltersUpselling'
import { CombinedFilterAddButton } from './components/CombinedFilterAddButton'
import { FiltersList } from './components/FiltersList'

const UnifiedFiltersListPage: FC = () => {
  const initPage = useAtomCallback(useCallback(initPageCallback, []))
  const handleReload = initPage

  useEffect(() => {
    void initPage()
  }, [initPage])

  const hasEngamentFilters = evalCondition(
    routesAccessConditions.engagement,
  ) as boolean

  return (
    <>
      <Header />
      <ModalDelete />
      <Page onReload={handleReload}>
        <ToastContainer />
        <Tooltip />
        <Flex flexDirection='column' gap='24px'>
          {!hasEngamentFilters && <EngagementFiltersUpselling />}
          <Search />
          <FiltersList />

          <Flex flexDirection='row' justifyContent='end'>
            <CombinedFilterAddButton />
          </Flex>
        </Flex>
      </Page>
    </>
  )
}

export default UnifiedFiltersListPage
